export const BackLoaded: Record<number, Record<number, number>> = {
  1: { 1: 100 },
  2: { 1: 25, 2: 75 },
  3: { 1: 20, 2: 30, 3: 50 },
  4: { 1: 10, 2: 20, 3: 30, 4: 40 },
  5: { 1: 5, 2: 10, 3: 15, 4: 30, 5: 40 },
  6: { 1: 5, 2: 10, 3: 12.5, 4: 17.5, 5: 25, 6: 30 },
  7: { 1: 5, 2: 5, 3: 10, 4: 12.5, 5: 17.5, 6: 25, 7: 25 },
  8: { 1: 2.5, 2: 2.5, 3: 5, 4: 10, 5: 12.5, 6: 17.5, 7: 25, 8: 25 },
  9: { 1: 2, 2: 2, 3: 5, 4: 7.5, 5: 10, 6: 12.5, 7: 17, 8: 20, 9: 24 },
  10: {
    1: 1.5,
    2: 1.5,
    3: 2.5,
    4: 5,
    5: 7.5,
    6: 10,
    7: 12.5,
    8: 15,
    9: 20,
    10: 24.5,
  },
};
